export const  ChargingNetworkWiseConstant ={
    CHARGING_NETWORK_WISE_SAGA:"CHARGING_NETWORK_WISE_SAGA",
    CHARGING_NETWORK_WISE_REQUEST:"CHARGING_NETWORK_WISE_REQUEST",
    CHARGING_NETWORK_WISE_RESPONSE:"CHARGING_NETWORK_WISE_RESPONSE",
    CHARGING_NETWORK_WISE_API:   "/all/coupons",
   }